
import { WarningProps } from 'lib/types';
import { SplitLayout } from '../components/SplitLayout';
import {Warning} from '../lib/components';
import { Box } from '@enaep-ng/benchmark';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { IADPState } from 'Types/AppStateTypes';
import { createSetViewAction } from 'state/reducer';
import { useResolveServiceStatus } from 'hooks/useNetworkService';
import { LoadingView } from './LoadingView';
import { LoadingProps } from 'Types/ViewTypes';

export const ErrorLoadingView = () => {
  const [wait, setWait] = useState(false);
  const state = useSelector(
    (state: { rootState: IADPState }) => state.rootState
  );
  const content = useSelector(
    (state: { rootState: IADPState }) => state.rootState.currentLanguageContent
  );
  const dispatch = useDispatch();
  const {checkOnlineServerAvailability}  = useResolveServiceStatus();
  const lastView = state.sessionState.lastKnownGoodState
  const actionsContent = content?.actions;

  const onTryAgain =()=>{
      window.location.reload();
  }
  const warningMsg = {
    "code": "Error code: 000",
    "title": "Failed to load the application.",
    "message": "An error has been encountered and the application has stopped working.<br/>Please try again. If problems persist, please contact the NAEP Help Desk"
  }

  const warningProps: WarningProps = {
      errorCode: "",
      title: warningMsg.title,
      message: warningMsg.message,
      buttons:[{
        label: actionsContent?.tryAgain || "Try Again",
        action:onTryAgain,
        variant: "primary"
    },{
          label: actionsContent?.exit || "Exit NAEP",
          action:()=>{window.close()},
          variant: "secondary"
      }, ]
    }
  const loadingViewProps: LoadingProps = {
    title: "Loading",
    message: "",
    subTitle: "Please Wait",
  }
  return (
    <>
    {wait ? (<LoadingView {...loadingViewProps}/>) 
    :
    (
      <SplitLayout alignment='left'>
      <Box className="fixedHeight" />
      <Box sx={{
          padding:"calc(22px * var(--zoom))", 
          textAlign: 'left'
        }}>
        <Warning {...warningProps}/>
      </Box>
    </SplitLayout>
    )}
    </>
  )
}
